import React from "react";
import { Box, Flex, Heading, Text, Stack } from "@chakra-ui/core";
import Feature from "../elements/Feature";
import ScreenMockup from "../mockups/ScreenMockup";
import { MdAccountBalance, MdMonetizationOn } from "react-icons/md";
import { FaLink } from "react-icons/fa";
import CallToAction from "../elements/CallToAction";
import CreateLinkFormMockup from "../mockups/CreateLinkFormMockup";

function LandingSectionTwo() {
  return (
    <Box background="#D1FACE" w="100%" py={["48px", "60px", "72px", "76px"]}>
      <Flex maxW="1490px" flexWrap="wrap-reverse" m="auto" w="100%">
        <Box
          pt={["30px", "40px", "30px", "0px"]}
          pb="20px"
          w={["100%", "100%", "100%", "50%"]}
          background={["#D1FACE", "#D1FACE", "#D1FACE", "none"]}
        >
          <ScreenMockup
            perspective="translateZ(-1000px) perspective(2000px) rotateY(15deg) rotateX(10deg)"
            section="Payment request"
            size="small"
          >
            <CreateLinkFormMockup />
          </ScreenMockup>
        </Box>
        <Box
          minWidth="340px"
          w={["100%", "100%", "100%", "50%"]}
          px="16px"
          m="auto"
        >
          <Box m="auto" w="100%" maxW="xl">
            <Heading
              as="h1"
              size="xl"
              lineHeight="shorter"
              fontWeight="bolder"
              color="primary.500"
              textAlign={["center", "center", "left", "left"]}
            >
              Online payment platform
              <Box as="span" color="success.500">
                <br />
                for offline business
              </Box>
            </Heading>

            <Text
              opacity="0.7"
              fontSize="lg"
              mt="2"
              textAlign={["center", "center", "left", "left"]}
            >
              Create links, share it with your invoice, and start receiving
              payments from your customers. Cut back on the wasted time and
              resources associated with gathering payments from offline orders.
            </Text>

            <Stack pl={8} mt="6">
              <Feature title="Setup your account" icon={MdAccountBalance}>
                Set-up your account with your bank details to receive funds
              </Feature>
              <Feature title="Send payment request link" icon={FaLink}>
                Engage & share payment request links with customers.
              </Feature>
              <Feature title="Receive funds" icon={MdMonetizationOn}>
                Get your funds wired daily to your registered account.
              </Feature>
            </Stack>
            <Stack justifyContent="center" isInline my="12px">
              <CallToAction />
            </Stack>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
}

export default LandingSectionTwo;
